import {useNavigate} from '@github-ui/use-navigate'
import {PencilIcon} from '@primer/octicons-react'
import {IconButton, type IconButtonProps} from '@primer/react'

import {useShortcut} from '../../hooks/shortcuts'

export function EditButton({
  disabled,
  editPath,
  editTooltip,
  loggedIn,
  siteNavLoginPath,
  hidden,
  customSx,
  buttonVariant,
}: {
  disabled: boolean
  editPath?: string
  editTooltip: string
  loggedIn: boolean
  siteNavLoginPath: string
  hidden?: boolean
  customSx?: Record<string, unknown>
  buttonVariant?: IconButtonProps['variant']
}): JSX.Element | null {
  const {editFileShortcut} = useShortcut()
  const sx = disabled ? {color: 'var(--color-primer-fg-disabled)'} : undefined
  const hiddenSx = hidden ? {display: 'none'} : undefined
  const navigate = useNavigate()
  return (
    <IconButton
      icon={PencilIcon}
      sx={{
        ...sx,
        ...hiddenSx,
        ...customSx,
      }}
      aria-label={editTooltip}
      onClick={() => {
        if (loggedIn) {
          if (!disabled && editPath) {
            navigate(editPath)
          }
        } else {
          navigate(siteNavLoginPath)
        }
      }}
      data-hotkey={editFileShortcut.hotkey}
      disabled={loggedIn && disabled}
      size="small"
      title={editTooltip}
      variant={buttonVariant}
    />
  )
}

try{ EditButton.displayName ||= 'EditButton' } catch {}